import * as selectors from './mining.selectors';
import reducer from './mining.reducers';

export default reducer;
export { selectors, reducer };
export { MiningAction } from './mining.actions';
export { MiningEffects } from './mining.effects';
export { MiningState, MiningData } from './mining.models';
export { MiningService } from './mining.service';
